
// import React from "react"
// import { format, addMonths, subMonths } from "date-fns"
// import { cn } from "../../lib/utils"
// import { ChevronLeft, ChevronRight, X } from "lucide-react"
// import { PopoverContext } from "../ui/popover"

// // A simplified calendar component for React
// export function Calendar({ mode = "single", selected, onSelect, className, initialFocus = false }) {
//   const [currentMonth, setCurrentMonth] = React.useState(new Date())
//   const { setOpen } = React.useContext(PopoverContext)

//   // Generate days for the current month
//   const getDaysInMonth = (date) => {
//     const year = date.getFullYear()
//     const month = date.getMonth()
//     const daysInMonth = new Date(year, month + 1, 0).getDate()
//     const firstDayOfMonth = new Date(year, month, 1).getDay()

//     const days = []

//     // Add empty cells for days before the first day of the month
//     for (let i = 0; i < firstDayOfMonth; i++) {
//       days.push(null)
//     }

//     // Add days of the month
//     for (let i = 1; i <= daysInMonth; i++) {
//       days.push(new Date(year, month, i))
//     }

//     return days
//   }

//   const days = getDaysInMonth(currentMonth)

//   const handlePrevMonth = () => {
//     setCurrentMonth(subMonths(currentMonth, 1))
//   }

//   const handleNextMonth = () => {
//     setCurrentMonth(addMonths(currentMonth, 1))
//   }

//   const handleSelectDate = (date) => {
//     if (onSelect) {
//       onSelect(date)
//       setOpen(false) // Close the popover after selecting a date
//     }
//   }

//   const isSelected = (date) => {
//     if (!selected || !date) return false
//     return date.toDateString() === selected.toDateString()
//   }

//   const isToday = (date) => {
//     if (!date) return false
//     const today = new Date()
//     return date.toDateString() === today.toDateString()
//   }

//   return (
//     <div className={cn("p-3 bg-white border rounded-md shadow-md", className)}>
//       <div className="flex items-center justify-between mb-2">
//         <button onClick={handlePrevMonth} className="p-1 rounded-full hover:bg-gray-100" type="button">
//           <ChevronLeft className="h-4 w-4" />
//         </button>
//         <div className="font-medium">{format(currentMonth, "MMMM yyyy")}</div>
//         <button onClick={handleNextMonth} className="p-1 rounded-full hover:bg-gray-100" type="button">
//           <ChevronRight className="h-4 w-4" />
//         </button>
//       </div>
//       <div className="grid grid-cols-7 gap-1 text-center">
//         {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
//           <div key={day} className="text-xs font-medium py-1 text-gray-500">
//             {day}
//           </div>
//         ))}
//         {days.map((day, i) => (
//           <div key={i} className="p-1">
//             {day ? (
//               <button
//                 type="button"
//                 onClick={() => handleSelectDate(day)}
//                 className={cn(
//                   "w-8 h-8 rounded-full flex items-center justify-center text-sm transition-colors",
//                   isSelected(day)
//                     ? "bg-red-900 text-white hover:bg-red-800"
//                     : isToday(day)
//                       ? "bg-red-100 text-red-900 hover:bg-red-200"
//                       : "hover:bg-gray-100",
//                 )}
//               >
//                 {day.getDate()}
//               </button>
//             ) : null}
//           </div>
//         ))}
//       </div>
//       <div className="mt-2 flex justify-end">
//         <button
//           type="button"
//           onClick={() => setOpen(false)}
//           className="text-xs flex items-center text-gray-500 hover:text-gray-700"
//         >
//           <X className="h-3 w-3 mr-1" /> Close
//         </button>
//       </div>
//     </div>
//   )
// }

"use client";

import React from "react";
import { format, addMonths, subMonths } from "date-fns";
import { cn } from "../../lib/utils";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { PopoverContext } from "../ui/popover";

export function Calendar({
  mode = "single",
  selected,
  onSelect,
  className,
  initialFocus = false,
  disabled = () => false // ✅ NEW
}) {
  const [currentMonth, setCurrentMonth] = React.useState(new Date());
  const { setOpen } = React.useContext(PopoverContext);

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayOfMonth = new Date(year, month, 1).getDay();

    const days = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(null);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      days.push(new Date(year, month, i));
    }

    return days;
  };

  const days = getDaysInMonth(currentMonth);

  const handlePrevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const handleSelectDate = (date) => {
    if (onSelect && !disabled(date)) {
      onSelect(date);
      setOpen(false);
    }
  };

  const isSelected = (date) => {
    if (!selected || !date) return false;
    return date.toDateString() === selected.toDateString();
  };

  const isToday = (date) => {
    if (!date) return false;
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  return (
    <div className={cn("p-3 bg-white border rounded-md shadow-md", className)}>
      <div className="flex items-center justify-between mb-2">
        <button onClick={handlePrevMonth} className="p-1 rounded-full hover:bg-gray-100" type="button">
          <ChevronLeft className="h-4 w-4" />
        </button>
        <div className="font-medium">{format(currentMonth, "MMMM yyyy")}</div>
        <button onClick={handleNextMonth} className="p-1 rounded-full hover:bg-gray-100" type="button">
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-center">
        {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
          <div key={day} className="text-xs font-medium py-1 text-gray-500">
            {day}
          </div>
        ))}
        {days.map((day, i) => (
          <div key={i} className="p-1">
            {day ? (
              <button
                type="button"
                onClick={() => handleSelectDate(day)}
                disabled={disabled(day)} // ✅
                className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-sm transition-colors",
                  isSelected(day)
                    ? "bg-red-900 text-white hover:bg-red-800"
                    : isToday(day)
                    ? "bg-red-100 text-red-900 hover:bg-red-200"
                    : "hover:bg-gray-100",
                  disabled(day) && "opacity-30 cursor-not-allowed pointer-events-none" // ✅
                )}
              >
                {day.getDate()}
              </button>
            ) : null}
          </div>
        ))}
      </div>

      <div className="mt-2 flex justify-end">
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="text-xs flex items-center text-gray-500 hover:text-gray-700"
        >
          <X className="h-3 w-3 mr-1" /> Close
        </button>
      </div>
    </div>
  );
}
